import * as React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { WrappedFormUtils } from "antd/lib/form/Form";
import { useState } from "src/ReactTS";
import CommissionCalculationDescriptionModal from "./CommissionCalculationDescriptionModal";
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import { IPricing } from 'src/services/interfaces/calculator/IPricing';

interface ICommissionCalculationDescriptionButton {
  pricing?: IPricing;
  form?: WrappedFormUtils;
  buttonFormat?: boolean;
  buttonText?: string;
}

const CommissionCalculationDescriptionButton = (props: ICommissionCalculationDescriptionButton) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      {props.buttonFormat ? (
        <button className="view-bcheck btn" onClick={() => setShowModal(true)} >
          <FontAwesomeIcon icon={faQuestionCircle} />  {props.buttonText}
        </button>
      ) : (<FontAwesomeIcon icon={faQuestionCircle} onClick={() => setShowModal(true)} />)
      }

      {showModal && <CommissionCalculationDescriptionModal pricing={props.pricing} OnCancel={() => setShowModal(false)} />}
    </>
  );
};

export default CommissionCalculationDescriptionButton;



// WEBPACK FOOTER //
// ./src/pages/monitor/my-quotes/commission-information/CommissionCalculationDescriptionButton.tsx